import { notificationService } from '@/Core/Services/NotificationService'
import { App } from 'antd'
import { useEffect } from 'react'

/**
 * Хук для ініціалізації NotificationService з Ant Design notification
 *
 * Повинен викликатися один раз в кореневому Layout компоненті після App.useApp()
 *
 * @example
 * ```tsx
 * function RootLayout() {
 *   useInitializeNotification()
 *   return <Outlet />
 * }
 * ```
 */
export function useInitializeNotification(): void {
    const { notification, message, modal } = App.useApp()

    useEffect(() => {
        notificationService.initialize(notification, message, modal)
    }, [notification, message, modal])
}
